import { render, staticRenderFns } from "./Tablist.vue?vue&type=template&id=f2d0e3ba&scoped=true&"
import script from "./Tablist.vue?vue&type=script&lang=js&"
export * from "./Tablist.vue?vue&type=script&lang=js&"
import style0 from "./Tablist.vue?vue&type=style&index=0&id=f2d0e3ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d0e3ba",
  null
  
)

export default component.exports